import GET_ARTICLES from '../plugins/getArticles'

const [ w, l, d ] = [ window, location, document ]

const init = () => {
  $('.block_foot').insertBefore('.p-strength-pickup')
}

export default function STRENGTH() {
  $( init )

  $(w).on('load', () =>{

    const id = l.search ? l.search.match(/article=(\d+)/)[1] : '1'
    switch(id){
      case '1': {
        GET_ARTICLES('.p-strength-case [data-plugin="getArticles"]',{
          makeItem(item,opt){
            const newitem = (item.is_new)? 'NEW':''
            const keywords = (item.keywords).toString()
            const keyword = keywords.split(",")
            return $(`
            <a href="${item.href}" class="p-strength-case__item">
              <div class="p-strength-case__item-inner">
                <figure class="p-strength-case__item__img" style="background-image:url('${item.thumb}')">
                  <img src="${item.thumb}" width="204" alt="${item.title}">
                </figure>
                <span class="category">${item.category.name}</span>
              </div>
              <div class="p-strength-case__item__body">
                <small class="date">${item.date}</small>
                <div class="p-strength-case__item__title">${item.title}<small class="new">${newitem}</small></div>
                <div class="keywords-inner">${keyword}</div>
              </div>
            </a>
          `)[0]
          }
        });
      }break;
			case '2': break;
    }
  })
}